import { decoders } from './decoders';
import { root } from './monitors';

export const monitors = {
  ...root,
  decoders,
};
